jQuery(document).ready(function ($) {
  if ($('body').hasClass('page-template-ocrolus-2023')) {
    const chart2023Q4Revenue = document.getElementById('2023-q4-revenue');

    new Chart(chart2023Q4Revenue, {
      type: 'line',
      data: {
        labels: ['Jul \'22', 'Aug \'22', 'Sep \'22', 'Oct \'22', 'Nov \'22', 'Dec \'22', 'Jan \'23', 'Feb \'23', 'Mar \'23', 'Apr \'23', 'May \'23', 'Jun \'23', 'Jul \'23', 'Aug \'23', 'Sep \'23', 'Oct \'23', 'Nov \'23', 'Dec \'23'],
        datasets: [{
          label: 'Median Revenue',
          data: ['41200', '47100', '46200', '48318', '49195', '53390', '54239', '50769', '56681.5', '49842', '55721', '55063.5', '54160', '59440', '55939', '61193', '56829', '55566'],
          borderColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Months',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Median Revenue',
            },
            ticks: {
              stepSize: 5000,
              callback: function (value, index, ticks) {
                return '$' + Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]);
              }
            },
            min: 40000,
            max: 65000,
          }
        }
      }
    });

    const chart2023Q4RevToExp = document.getElementById('2023-q4-revtoexp');

    new Chart(chart2023Q4RevToExp, {
      type: 'line',
      data: {
        labels: ['Jul \'22', 'Aug \'22', 'Sep \'22', 'Oct \'22', 'Nov \'22', 'Dec \'22', 'Jan \'23', 'Feb \'23', 'Mar \'23', 'Apr \'23', 'May \'23', 'Jun \'23', 'Jul \'23', 'Aug \'23', 'Sep \'23', 'Oct \'23', 'Nov \'23', 'Dec \'23'],
        datasets: [{
          label: 'Revenue-to-Expense Ratio',
          data: ['99.23', '99.72', '99.53', '99.94', '99.14', '99.55', '99.95', '100.52', '100.86', '100.13', '101.18', '100.87', '101.15', '100.73', '100.22', '100.93', '99.40', '99.10'],
          borderColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Months',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Ratio',
            },
            ticks: {
              stepSize: 2,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            min: 95,
            max: 105,
          }
        }
      }
    });

    const chart2023Q4PayToRev = document.getElementById('2023-q4-paytorev');

    new Chart(chart2023Q4PayToRev, {
      type: 'line',
      data: {
        labels: ['Jul \'22', 'Aug \'22', 'Sep \'22', 'Oct \'22', 'Nov \'22', 'Dec \'22', 'Jan \'23', 'Feb \'23', 'Mar \'23', 'Apr \'23', 'May \'23', 'Jun \'23', 'Jul \'23', 'Aug \'23', 'Sep \'23', 'Oct \'23', 'Nov \'23', 'Dec \'23'],
        datasets: [{
          label: 'Payroll-to-Revenue Ratio',
          data: ['18.57', '16.59', '19.42', '17.23', '18.46', '20.24', '17.51', '19.30', '18.89', '18.72', '17.31', '19.21', '17.21', '18.11', '19.07', '17.58', '20.27', '20.50'],
          borderColor: '#0064dd',
        }]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Months',
            },
            grid: {
              color: '#fff',
              tickLength: -6,
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
          },
          y: {
            border: { display: false },
            title: {
              display: true,
              text: 'Ratio',
            },
            ticks: {
              stepSize: 2,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            min: 16,
            max: 22,
          }
        }
      }
    });
  }
});
